import { useEffect, useState } from "react";
import { localProjects, Project } from "../data/projects";
import { ProjectSource, subscribeToProjects } from "../services/projects";

type ProjectsState = {
  error: Error | null;
  projects: Project[];
  source: ProjectSource;
};

export function useProjects(): ProjectsState {
  const [state, setState] = useState<ProjectsState>({
    error: null,
    projects: localProjects,
    source: "local",
  });

  useEffect(() => {
    return subscribeToProjects(
      (projects, source) => {
        setState({
          error: null,
          projects,
          source,
        });
      },
      (error) => {
        setState({
          error,
          projects: localProjects,
          source: "local",
        });
      },
    );
  }, []);

  return state;
}
